import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import clsx from "classnames";
import PropTypes from "prop-types";
import Form from "@/components/Shared/Form";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import StarIcon from "/public/site-assets/svg/star.svg";
import { useState, useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function TextWithVideo({
  className,
  global,
  pathPrefix,
  heading,
  content,
  post,
  imageURL,
  video,
}) {
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
    });

    Fancybox.bind("[data-fancybox]", {
      on: {
        close: () => {
          setPlayVideo(false);
        },
      },
    });
  }, []);

  useEffect(() => {
    if (playVideo) {
      document.querySelector("[data-fancybox]").click();
    }
  }, [playVideo]);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .fancybox__container {
        --fancybox-bg: rgba(24, 24, 27, 0.5) !important;
      }
      .with-fancybox {
        --fancybox-scrollbar-compensate: 0 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <section className={clsx(className, styles.root)}>
        <Container>
          <div className="wrapper">
            <div onClick={() => setPlayVideo(true)} className='bg-transparent border-0' role="button">
              <EditableImage
                className={`featured-video position-relative`}
                img={{
                  path: `${pathPrefix}.image`,
                  src: `${imageURL ? imageURL : "/images/placeholders/video-placeholder.png"}`,
                }}
                size={"800x"}
                alt={``}
                height={`auto`}
              />
            </div>
            <a
              data-fancybox
              href={video}
              style={{ display: "none" }}
            >
              Hidden Link
            </a>
            <div>
              {heading && (
                <EditableText
                  content={heading}
                  path={`${pathPrefix}.heading`}
                  global={global}
                  tag={`h2`}
                  className={`h2 mb-3 position-relative z-index-1`}
                />
              )}
              {content && (
                <EditableText
                  content={content}
                  path={`${pathPrefix}.content`}
                  global={global}
                  tag={`div`}
                  className={`content focused-text position-relative z-index-1`}
                  html={true}
                />
              )}
              <span className="floating-icons">
                <StarIcon />
              </span>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

TextWithVideo.defaultProps = {
  pathPrefix: "",
  className: "py-5",
  video: "",
};

TextWithVideo.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
  video: PropTypes.string,
};